<script setup lang="ts">
import GInputText from "./GInputText.vue";
import GInputLongText from "./GInputLongText.vue";
import { createFormControl, type FormControl } from "@/utils/forms";
import { defineAsyncComponent, watch } from 'vue';
import { Validators } from '@/utils/validations';
import type { InputField } from '@/interfaces/common/input_fields';
import GInputCheckbox from "./GInputCheckbox.vue";

// Carregados sob demanda: cada um embute um componente Syncfusion pesado
const GInputSmartSelect = defineAsyncComponent(() => import("./GInputSmartSelect.vue"));
const GInputRickText = defineAsyncComponent(() => import("./GInputRickText.vue"));
const GInputColor = defineAsyncComponent(() => import("./GInputColor.vue"));
const GInputSelect = defineAsyncComponent(() => import("./GInputSelect.vue"));


const props = defineProps<{
    control?: FormControl
    modelValue?: any;
    field: InputField
}>();

const emit = defineEmits<{
    (e: 'update:modelValue', value: string): void;
}>();

const _control = props.control ?? createFormControl(props.modelValue);

watch(() => _control.value, (newValue) => {
    emit("update:modelValue", newValue);
})

watch(() => props.field.required, (value) => {
    if (value) {
        _control.addValidator(Validators.required);
    } else {
        _control.removeValidator(Validators.required);
    }
}, { immediate: true })

watch(() => (props.field as any).maxLength, (value) => {
    if (value) {
        _control.removeValidator(Validators.maxLength(value));
        _control.addValidator(Validators.maxLength(value));
    } else {
        _control.removeValidator(Validators.maxLength(0));
    }

}, { immediate: true })

</script>


<template>
    <div>

        <GInputText v-if="field.type == 'text'" :label="field.label" :icon="field.icon" :control="_control">
        </GInputText>

        <GInputLongText v-else-if="field.type == 'longtext'" :label="field.label" :control="_control"
            :rows="field.rows">
        </GInputLongText>

        <GInputSmartSelect v-else-if="field.type == 'smart-select'" :label="field.label" :url="field.url"
            :filter="field.filter" :columns="field.columns" :control="_control">
        </GInputSmartSelect>

        <GInputCheckbox v-else-if="field.type == 'checkbox'" :label="field.label" :control="_control"></GInputCheckbox>

        <GInputRickText v-else-if="field.type == 'rich-text'" :label="field.label" :control="_control"></GInputRickText>

        <GInputColor v-else-if="field.type == 'color'" :label="field.label" v-model="_control.value" mode="Picker">
        </GInputColor>

        <GInputSelect v-else-if="field.type == 'select'" :label="field.label" :options="field.options"
            :control="_control">
        </GInputSelect>

    </div>


</template>